import { IController } from 'angular';
import * as _ from 'lodash';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImGapPlan } from 'Src/ng2/shared/services/im-models/im-gap-plan';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { ICourseDiff } from '../../../../../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { IGapPlan } from '../../../../../../../../ng2/shared/typings/interfaces/gap-plan.interface';
import { IStudent } from '../../../../../../../../ng2/shared/typings/interfaces/student.interface';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export interface IProgramChanges {
  currentGapPlans: IGapPlan[];
  futureGapPlans: IGapPlan[];
  courseDiffs: ICourseDiff[];
}

export class MonitorProgramChangesStepCtrl implements IController {
  static $inject: string[] = [
    '$scope',
    'ImSchool',
    'CourseDiff',
    'GapPlan',
    'WizardUtils',
    'ImGapPlan',
    'ImCourseDiff',
  ];

  public sort: string;
  public currentTermYear: number;
  public courseAdds;
  public courseDrops;
  public currentGapPlansCount: number;
  public futureGapPlansCount: number;
  private programChanges: IProgramChanges;
  private courseDiffsBucket: ICourseDiff[];
  private allUnFlattenedStudents: IStudent[];
  private school;

  // bindings
  public selectedGradDate: string | null;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private CourseDiff,
    private GapPlan,
    private WizardUtils: WizardUtils,
    private imGapPlan: ImGapPlan,
    private imCourseDiff: ImCourseDiff,
  ) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    // needed for active gap plan join
    this.allUnFlattenedStudents = this.WizardUtils.getFilteredUnflattenedStudents();
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    const courseDiffFilter = {
      termYear: this.currentTermYear,
      status: 'PENDING',
    };
    this.programChanges = this.getAllProgramChanges();
    this.courseDiffsBucket = this.programChanges.courseDiffs;
    this.courseAdds = this.imCourseDiff.filterForAddCourseDiffs(this.courseDiffsBucket, courseDiffFilter);
    this.courseDrops = this.imCourseDiff.filterForDropCourseDiffs(this.courseDiffsBucket, courseDiffFilter);
    this.currentGapPlansCount = this.programChanges.currentGapPlans.length;
    this.futureGapPlansCount = this.programChanges.futureGapPlans.length;
  }

  private getAllProgramChanges() {
    const baseObj: IProgramChanges = { currentGapPlans: [], futureGapPlans: [], courseDiffs: [] };
    return _.reduce(
      this.allUnFlattenedStudents,
      (result, student: IStudent) => {
        const { join_activeGapPlans: activeGapPlans, join_pendingCourseDiffs } = student;
        _.each(activeGapPlans, (_gapPlan: IGapPlan) => {
          const gapPlan: IGapPlan = new this.GapPlan(_gapPlan);
          if (this.imGapPlan.isActiveForCurrentTerm(gapPlan, this.currentTermYear)) {
            result.currentGapPlans.push(gapPlan);
          } else if (this.imGapPlan.isActiveForFutureTerm(gapPlan, this.currentTermYear)) {
            result.futureGapPlans.push(gapPlan);
          }
        });

        _.each(join_pendingCourseDiffs, (pendingCourseDiff: ICourseDiff) => {
          result.courseDiffs.push(pendingCourseDiff);
        });

        return result;
      },
      baseObj,
    );
  }
}
